import { ref, watch } from "vue";
import Tooltip from 'components/Tooltip/Tooltip.vue'

export default {
    name: 'DynamicTable',
    components: {
        Tooltip,
    },
    props: {
        headers: {
            type: Object,
            required: true,
        },
        rows: {
            type: Object,
            required: true,
        },
    },
    setup(props) {
        const processedRows = ref([]);
        const rowLinks = ref({});

        const processRows = (rows) => {
            rowLinks.value = {};
            return rows.map((row, index) => {
                const first = row[0]

                if (!first || typeof first !== 'object') {
                    console.log("HERE", row)
                    return row
                }

                const hasOnlyHref = Object.keys(first).length === 1 && 'href' in first
                if (hasOnlyHref) {
                    rowLinks.value[index] = first.href
                }
                return hasOnlyHref ? row.slice(1) : row
            });
        };

        const handleRowClick = (href) => {
            if (!href) return
            window.location.href = href
        };

        processedRows.value = processRows(props.rows)

        watch(() => props.rows, (newRows) => {
            processedRows.value = processRows(newRows);
        });

        return {
            processedRows,
            rowLinks,
            handleRowClick,
        }
    },
}
